"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlavorisationBCP47 = exports.InterslavicBCP47 = void 0;
exports.InterslavicBCP47 = {
    Generic: 'isv',
    Latin: 'isv-Latn',
    Cyrillic: 'isv-Cyrl',
    Glagolitic: 'isv-Glag',
    IPA: 'isv-x-fonipa',
};
exports.FlavorisationBCP47 = {
    ...exports.InterslavicBCP47,
    ASCII: 'isv-Latn-x-ascii',
    LatinEtymological: 'isv-Latn-x-etymolog',
    LatinNorthern: 'isv-Latn-x-northern',
    LatinSlovianto: 'isv-Latn-x-sloviant',
    LatinSouthern: 'isv-Latn-x-southern',
    Polish: 'isv-Latn-PL',
    GlagoliticEtymological: 'isv-Glag-x-etymolog',
    GlagoliticNorthern: 'isv-Glag-x-northern',
    GlagoliticSlovianto: 'isv-Glag-x-sloviant',
    GlagoliticSouthern: 'isv-Glag-x-southern',
    CyrillicEtymological: 'isv-Cyrl-x-etymolog',
    CyrillicIotated: 'isv-Cyrl-x-iotated',
    CyrillicIotatedExtended: 'isv-Cyrl-x-iotated-ext',
    CyrillicNorthern: 'isv-Cyrl-x-northern',
    CyrillicSlovianto: 'isv-Cyrl-x-sloviant',
    CyrillicSouthern: 'isv-Cyrl-x-southern',
};
//# sourceMappingURL=bcp47.js.map